import React from 'react';

export default function SvgIcon(props) {
    return (
        <svg viewBox={props.glyph.viewBox} {...props}>
            <use xlinkHref={`#${props.glyph.id}`} />
        </svg>
    );
}



// WEBPACK FOOTER //
// ./src/presentation/SvgIcon.js